import axios from 'axios';

let prefix = "/app-version"

const AppVersionApi = {
	
	getVersions(payload){
		return axios.get(prefix + "/versions", {params: payload})
	},
	updateVersions(payload){
		return axios.post(prefix + "/versions", payload)
	},

}

export default AppVersionApi;
